module.exports = __webpack_public_path__ + "static/media/0005.0cea197e.jpg";